import { render, staticRenderFns } from "./FightersAgreementDialog.vue?vue&type=template&id=0749fb0e&scoped=true"
import script from "./FightersAgreementDialog.vue?vue&type=script&lang=js"
export * from "./FightersAgreementDialog.vue?vue&type=script&lang=js"
import style0 from "./FightersAgreementDialog.vue?vue&type=style&index=0&id=0749fb0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0749fb0e",
  null
  
)

export default component.exports